import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=e4836ed0&scoped=true&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=e4836ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4836ed0",
  null
  
)

export default component.exports